import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'

import { LevelTag } from '..'
import { EinvoiceValidationresult } from '../../../../data/models'
import { getResultTranslation } from '../../utils'

type Props = {
  resultObject: EinvoiceValidationresult | null
  visible: boolean
  setVisible: (visible: boolean) => void
}

export const DetailsDialog: React.FC<Props> = ({
  resultObject,
  visible,
  setVisible,
}) => {
  const { t } = useTranslation()

  const footer = (
    <Button
      label={t(
        'eInvoiceDetails.stepper.validation.card.content.details.dialog.close.label',
      )}
      icon="pi pi-times"
      onClick={() => setVisible(false)}
      className="p-button-text"
    />
  )

  return (
    <Dialog
      header={t(
        'eInvoiceDetails.stepper.validation.card.content.details.dialog.title',
      )}
      visible={visible}
      style={{ width: '50vw' }}
      onHide={() => setVisible(false)}
      footer={footer}
    >
      <div className="grid">
        {/* Validation type */}
        <div className="field col-12 lg:col-8">
          <label htmlFor="validationType" className="text-sm font-bold">
            {t(
              'eInvoiceDetails.stepper.validation.card.content.details.dialog.form.validationType.label',
            )}
          </label>
          <InputText
            id="validationType"
            value={
              resultObject?.ValidationType
                ? t(
                    `eInvoiceDetails.stepper.validation.card.content.details.dialog.form.validationType.options.${resultObject?.ValidationType}`,
                  )
                : ''
            }
            className="w-full"
            disabled
          />
        </div>

        {/* Level */}
        <div className="field col-12 lg:col-4">
          <label htmlFor="level" className="text-sm font-bold">
            {t(
              'eInvoiceDetails.stepper.validation.card.content.details.dialog.form.level.label',
            )}
          </label>
          <div id="level" className="flex items-center h-full pt-2">
            <div>
              <LevelTag level={resultObject?.Level} />
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="field col-12">
          <label htmlFor="description" className="text-sm font-bold">
            {t(
              'eInvoiceDetails.stepper.validation.card.content.details.dialog.form.description.label',
            )}
          </label>

          <InputTextarea
            id="description"
            className="w-full"
            value={getResultTranslation('title', resultObject)}
            disabled
          />
        </div>

        {/* Details */}
        <div className="field col-12">
          <label htmlFor="details" className="text-sm font-bold">
            {t(
              'eInvoiceDetails.stepper.validation.card.content.details.dialog.form.details.label',
            )}
          </label>
          <InputTextarea
            id="details"
            className="w-full"
            rows={12}
            value={getResultTranslation('description', resultObject)}
            disabled
          />
        </div>
      </div>
    </Dialog>
  )
}
